import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { secondary } from 'styles/theme';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, ChartDataLabels, Title, Tooltip, Legend);

const labels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]

const PisaBarChart = (props) => {
    const { showGoResult } = props

    const datasets = useMemo(
        () => [
            {
                data: [20, 19, 18, 17, 16, 15, 14, 13, 12, 12, 11, 10, 9, 8, 7, 6.8, 6.5, 6.4, 6.3, 6.2, 6.2],
                backgroundColor: ['#E1E1E1', '#E1E1E1', '#E1E1E1', '#E1E1E1', '#E1E1E1', '#E1E1E1', '#E1E1E1', '#E1E1E1', secondary, '#E1E1E1', '#E1E1E1', '#E1E1E1', '#E1E1E1', '#FEE4D8', '#E1E1E1', '#E1E1E1', '#E1E1E1'],
                borderWidth: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                borderColor: [secondary],
            },
        ], [showGoResult]
    )

    const data = {
        labels: labels,
        datasets: datasets
    };

    const options = {
        responsive: true,
        scales: {
            y: {
                beginAtZero: true, // Start the y-axis at zero
                ticks: {
                    display: false, // Hide x-axis labels
                },
            },
            x: {
                beginAtZero: true, // Start the y-axis at zero
                ticks: {
                    display: false, // Hide x-axis labels
                },
                grid: {
                    display: false, // Hides the y-axis grid lines
                },
            },
        },
        plugins: {
            legend: {
                display: false
            },
            datalabels: {
                color: secondary,
                anchor: 'border',
                align: 'top',
                offset: 80,
                font: {
                    size: 16
                },
                formatter: (value, { dataIndex }) => {
                    if (dataIndex === 11)
                        return "התלמידים שלך עם go"
                    else if (dataIndex === 14)
                        return "ישראל"
                    return ""
                }
            },
            title: {
                display: false,
            },
        },
    };

    return <Bar key={"pisa-bar-chart"} height={140} width={800} data={data} options={options} />;
};

export default PisaBarChart